/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  path {
    fill: #98d515;
  }
  react {
    fill: #203040;
  }
`

export default class ScashIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" css={Color}>
        <g id="그룹_4891" data-name="그룹 4891" transform="translate(-403 -185)">
          <rect id="사각형_2474" data-name="사각형 2474" width="46" height="53" transform="translate(420 198)" fill="#203040"/>
          <path id="icon_cash"
                d="M40,80A37.86,37.86,0,0,1,11.731,68.346C3.727,60.394,0,51.471,0,40.265,0,28.861,3.837,19.5,11.731,11.654A37.86,37.86,0,0,1,40,0,37.838,37.838,0,0,1,68.264,11.654C76.161,19.5,80,28.859,80,40.265A38.3,38.3,0,0,1,68.264,68.346,37.854,37.854,0,0,1,40,80Zm2.515-62.858c-11.576,0-19.661,9.094-19.661,22.115s7.785,21.776,19.373,21.776A17.1,17.1,0,0,0,55.711,54.8l-4.454-5.261a11.765,11.765,0,0,1-8.743,4.171c-6.8,0-11.031-5.648-11.031-14.74,0-8.718,4.5-14.575,11.2-14.575,2.818,0,5.287,1.126,7.771,3.544l4.459-5.369A17.231,17.231,0,0,0,42.515,17.142Z"
                transform="translate(403 185)" fill="#98d515"/>
        </g>
      </svg>
    )
  }
}
